import React, {useState} from 'react'
import {default as Apiservices} from '../../../../../../src/common/index'
import {useNavigate} from 'react-router-dom'
import Modal from 'react-bootstrap/Modal'
import {ToastContainer, toast} from 'react-toastify'
import 'react-toastify/dist/ReactToastify.css'
import BackDrop from '../../timesheetentry/ComponentBackdrop'
import AnnouncementPop from '../modal/AnnouncementPop'

export default function MonthlyCommentsPop(props: any) {
  const navigate = useNavigate()
  const [show, setShow] = useState(true)
  const [message, setMessage] = useState(false)
  const [showBackDrop, setShowBackDrop] = useState(true)
  const [isLoading, setIsLoading] = useState<any | []>(false)
  const [announcement_open_popup, setAnnouncementOpenPoup] = useState(false)

  const handleClose = () => {
    setShow(false)
    props && props?.close(false)
    props && props?.setShow(false)
    props && props?.setWorkLocationShow(false)
  }
  return (
    <>
      <Modal
        show={show}
        onHide={handleClose}
        aria-labelledby='contained-modal-title-vcenter'
        centered
        keyboard={false}
        backdrop='static'
      >
        {props && props?.view_open && (
          <div className='col-auto'>
            <button
              type='button'
              className='btn-close'
              data-bs-dismiss='modal'
              aria-label='Close'
              onClick={props && props?.cancel}
            ></button>
          </div>
        )}
        <Modal.Body>
          <>
            <div className='text-center fw-bold fs-5 text-gray-800'>Alert</div>
            <p className='text-center text-gray-600 fs-5 fw-semibold text-transform-unset'>
              Project status update(s) exist at the weekly entries. Do you wish to override them?
            </p>
          </>
          <div className='d-flex justify-content-center gap-3 py-2'>
            <>
              <div className=''>
                <button
                  className='btn btn-sm  btn-primary'
                  onClick={(e) => props && props?.CommentOverRidePop(e, 'yes')}
                >
                  Yes
                </button>
              </div>
              <div className=''>
                <button
                  className='btn btn-sm btn-danger'
                  onClick={(e) => props && props?.CommentRemainingOkPop(e, 'no')}
                >
                  No
                </button>
              </div>
            </>
          </div>
        </Modal.Body>
      </Modal>
      {/* )} */}
      <ToastContainer />
    </>
  )
}
